










































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {ActiveInject} from "@/support/reactive"
import {Nametag} from "@/design-system/constructs/Nametag/nametag.entity"

/**
 * @status stable
 * @typed
 * @published 5.0.0
 * @changelog 5.0.0 Published.
 * @changelog 5.0.1 Add `lastSeen` support.
 * @changelog 5.3.1 Changed the way user's timestamps are prioritized for JP-1558.
 * @changelog 5.11.0-rc.1 Adds context for a nametag inside meridian
 */
@Component
export default class JdsNametag extends Vue {

    @Prop() user!: Nametag
    @Prop({default: false}) context!: false|'admin-unit'

    @ActiveInject({from: 'jds.select-field.context', default: false}) selectContext!: boolean
    @ActiveInject({from: 'jds.table.context', default: false}) tableContext!: boolean
    @ActiveInject({from: 'jds.meridian.context', default: false}) meridianContext!: boolean

    get hideAdminUnitAspects () {
        return this.context === 'admin-unit'
    }

    get mode() {
        if (this.selectContext) return 'select'
        if (this.tableContext) return 'table'
        if (this.meridianContext) return 'meridian'

        return 'simple'
    }

    get initials() {
        if (!this.user.name) {
            return ''
        }
        return this.user.name.replace(/([^\p{L}\p{M}\p{Zs}\d\s])+/gu, '').split(' ').map(word => word[0]).join('')
    }

    get avatarStyles() {
        if (this.user.avatar) {
            return {
                backgroundImage: `url(${this.user.avatar})`,
                textIndent: '-999px'
            }
        } else {
            let fontSize = this.initials.length > 2 ? '65%' : '100%'
            if(this.meridianContext) {
                fontSize = this.initials.length > 2 ? '65%' : '80%'
            }
            return {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                fontSize,
                color: 'black'
            }
        }
    }
}
